export default {
    title: "Laser tubo",
    icon: "mdi-pipe",
    groups: ["Amministrazione"],
    submenu: [
        {
            title: "Commesse",
            route: { name: "laser-tube-laser" },
            groups: ["Amministrazione"],
        },
    ],
};
